export default __webpack_public_path__ + "static/media/Inter-Bold.828b5dfc.woff";